import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { OrganizationEditModal } from 'components/containers';
import { OrganizationTaxEditModal } from 'components/containers';
import { OrganizationVatExemptionEditModal } from 'components/containers';
import { Box, Button } from 'components/ui';
import { Stack } from '@mui/material';
import { getVatExtemptions } from 'utility/vat';

import * as Styled from './SettingsOrganization.styles';

export const SettingsOrganization = ({ organizationData, refetchOrganizationData }) => {
  const [isEdition, setIsEdition] = useState(false);
  const [isTaxEditEnabled, setIsTaxEditEnabled] = useState(false);
  const [isVatExemptionEditEnabled, setIsVatExemptionEditEnabled] = useState(false);
  const data = {
    name: get(organizationData, 'organization.company.name', ''),
    nip: get(organizationData, 'organization.company.nip.nip', ''),
    country: get(organizationData, 'organization.company.address.country', ''),
    city: get(organizationData, 'organization.company.address.city', ''),
    street: get(organizationData, 'organization.company.address.street', ''),
    houseNumber: get(organizationData, 'organization.company.address.houseNumber', ''),
    apartmentNumber: get(organizationData, 'organization.company.address.apartmentNumber', ''),
    zipCode: get(organizationData, 'organization.company.address.zipCode', ''),
    commune: get(organizationData, 'organization.company.address.commune', ''),
    county: get(organizationData, 'organization.company.address.county', ''),
    voivodeship: get(organizationData, 'organization.company.address.voivodeship', ''),
    email: get(organizationData, 'organization.company.email', ''),
    phone: get(organizationData, 'organization.company.phone', ''),
    cellPhone: get(organizationData, 'organization.company.cellPhone', ''),
    usKod: get(organizationData, 'organization.urzadSkarbowy.kod', ''),
    usNazwa: get(organizationData, 'organization.urzadSkarbowy.nazwa'),
    platnikVAT: get(organizationData, 'organization.podatekVATUstawienia.platnikVAT', true),
    zwolnienieVatPodstawa: get(organizationData, 'organization.podatekVATUstawienia.podstawa', 'BRAK_ZWOLNIENIA'),
    zwolnienieVatPodstawaInna: get(organizationData, 'organization.podatekVATUstawienia.podstawaInna'),
  };

  const platnikVatLabel = data.platnikVAT ? "Tak" : "Nie";
  const podstawaZwolnienia = getVatExtemptions().reduce((arr, obj) => (obj.value === data.zwolnienieVatPodstawa && arr.push(obj.label), arr), [])[0];
  const podstawaZwolnieniaLabel = (data.zwolnienieVatPodstawaInna != undefined && data.zwolnienieVatPodstawaInna != '') ? data.zwolnienieVatPodstawaInna : podstawaZwolnienia;

  return (
    <Styled.Wrapper>
      <Box title="Dane firmy">
      
        <Stack direction={{ xs: 'column', xl: 'row' }} justifyContent="flex-start" gap={1}>
          
          <Styled.InfoBox>
            <Styled.Title>{data.name}</Styled.Title>
            <Styled.Info>
              <div>
                <div className="item">
                  <span className="label">NIP:</span>
                  {data.nip}
                </div>
                <div className="item">
                  <span className="label">Ulica, nr, lokal:</span>
                  {data.street} {data.houseNumber} {data.apartmentNumber && `lokal ${data.apartmentNumber}`}
                </div>
                <div className="item">
                  <span className="label">Kod pocztowy:</span>
                  {data.zipCode}
                </div>
                <div className="item">
                  <span className="label">Miejscowość:</span>
                  {data.city}
                </div>
                <div className="item">
                  <span className="label">Kraj:</span>
                  {data.country}
                </div>
                <div className="item">
                  <span className="label">Gmina:</span>
                  {data.commune}
                </div>
                <div className="item">
                  <span className="label">Powiat:</span>
                  {data.county}
                </div>
                <div className="item">
                  <span className="label">Województwo:</span>
                  {data.voivodeship}
                </div>

                <Styled.Spacer />

                <div>
                  <div className="item">
                    <span className="label">Email:</span>
                    {data.email}
                  </div>
                  <div className="item">
                    <span className="label">Telefon:</span>
                    {data.phone}
                  </div>
                  <div className="item">
                    <span className="label">Tel. komórkowy:</span>
                    {data.cellPhone}
                  </div>
                </div>

                <Button variant="outlined" onClick={() => setIsEdition(true)}>
                  Edytuj
                </Button>
              </div>

            
            
            </Styled.Info>
          </Styled.InfoBox>
          
          
          <Styled.InfoBox>
          <Styled.Title>Ustawienia podatkowe</Styled.Title>
            <Styled.Info>
              <div>
                <div className="item">
                  <span className="label">Wybrany urząd skarbowy:</span>
                  {data.usNazwa}
                </div>
                <Button variant="outlined" onClick={() => setIsTaxEditEnabled(true)}>
                  Zmień
                </Button>
                <Styled.Spacer />
                <div className="item">
                  <span className="label">Płatnik VAT:</span>
                  {platnikVatLabel}
                </div>
                <div className="item">
                  <span className="label">Podstawa zwolnienia:</span>
                  {podstawaZwolnieniaLabel}
                </div>
                <Button variant="outlined" onClick={() => setIsVatExemptionEditEnabled(true)}>
                  Zmień
                </Button>
              </div>
            </Styled.Info>
          </Styled.InfoBox>
          
        </Stack>
        

        {isEdition && (
          <OrganizationEditModal
            onClose={() => setIsEdition(false)}
            organizationData={organizationData}
            onSuccess={() => {
              setIsEdition(false);
              refetchOrganizationData();
            }}
          />
        )}

        {isTaxEditEnabled && (
          <OrganizationTaxEditModal
            onClose={() => setIsTaxEditEnabled(false)}
            organizationData={organizationData}
            onSuccess={() => {
              setIsTaxEditEnabled(false);
              refetchOrganizationData();
            }}
          />
        )}

        {isVatExemptionEditEnabled && (
          <OrganizationVatExemptionEditModal
            onClose={() => setIsVatExemptionEditEnabled(false)}
            organizationData={organizationData}
            onSuccess={() => {
              setIsVatExemptionEditEnabled(false);
              refetchOrganizationData();
            }}
          />
        )}
      </Box>
    </Styled.Wrapper>
  );
};

SettingsOrganization.propTypes = {
  organizationData: PropTypes.object.isRequired,
  refetchOrganizationData: PropTypes.func.isRequired,
};
